import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

export default ({ close, show, title, termsAndConditions }) => (
  <Modal isOpen={show} className="terms-and-conditions-modal">
    <div>
      <p className="large-text mb-24 uppercase-text fw-800">
        {title || "Terms and Conditions"}
      </p>
      <div
        className="terms-and-conditions-box mb-24"
        style={{ lineHeight: "2", whiteSpace: "pre-wrap" }}
      >
        {termsAndConditions}
      </div>
      <p
        onClick={close}
        className="uppercase-text brand-color-text pointer modal-close fw-600 medium-text"
      >
        Close
      </p>
    </div>
  </Modal>
);
